import { Component, OnInit } from '@angular/core';
import { RouteService } from 'app/services/route.service';
import { PopupService } from 'app/services/shared/popup.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { UtilityServiceService } from 'app/services/utility-service.service';

@Component({
  selector: 'app-list-route',
  templateUrl: './list-route.component.html',
  styleUrls: ['./list-route.component.css'],
  providers: [RouteService]
})
export class ListRouteComponent implements OnInit {
  routes: any = [];
  message = "Loading Standard Routes...";
  public isLoading = false;
  showNum: number = 10;
  lblHeading = 'Standard Routes';
  isEmpty: boolean = false;

  constructor(private routeService: RouteService,
    private showModal: PopupService, private toastr: ToastrService,
    private routr: Router, public utility: UtilityServiceService) { }

  ngOnInit() {
    this.utility.setDirection(true);
    this.getRoutes();
  }
  getRoutes() {
    this.isLoading = true;
    this.routeService.getAllRoute().subscribe(data => {
      this.isLoading = false;
      this.routes = data;
      for (let index = 0; index < this.routes.length; index++) {
        let element = this.routes[index];
        if (element.route_type_ind == 1)
          element.route_type_ind = "Standard descriptive";
        if (element.route_type_ind == 3)
          element.route_type_ind = "Standard with legs/places";
        if (element.route_type_ind == 5)
          element.route_type_ind = "Standard desc & legs";
        if (element.route_type_ind == 11)
          element.route_type_ind = "Carrier-defined descriptive";
        if (element.route_type_ind == 13)
          element.route_type_ind = "Carrier-defined with legs/places";
        if (element.route_type_ind == 15)
          element.route_type_ind = "Carrier-defined desc & legs";
        this.routes[index] = element;
      }
      this.isEmpty = (this.routes.length == 0) ? true : false;
      this.utility.onSort(5);
    });
  }
  onConfirm(id) {

    this.showModal.showConfirm('Delete Standard Route', 'Are you sure you want to delete?', `You're about to delete Standard Route`, 'Yes', 'No')
      .subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.delete(id)
        } else {
          return;
        }
      });

  }
  delete(id) {
    this.routeService.deleteRoutes(id).subscribe((x: any) => {
      //console.log(x);
      this.getRoutes();
      this.isLoading = false;
      this.toastr.success('Delete Route', 'Route deleted successfully');
      this.routr.navigateByUrl('/route/management/list');
    },
      error => {
        //console.log(error.error.Message)
        this.isLoading = false;
        this.toastr.error('Failed to save application. If the problem persist, please contact system administrator.', 'Save Application')
        // this.showModal.showError('Save Application','Failed to save application. If the problem persist, please contact system administrator.',error);
        return;
      });
  }

}
